import React from "react";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import RenderField from "@xem/look/Renders/Field";
import opt from "@gqlapp/base/utils/opt";
import Row from "@gqlapp/base/Row";
import Col from "@gqlapp/base/Col";
import Checked from "@xem/icon/base/Checked.svg";

export default (function List(props){
	let { id: name, name: label, values, required, onActions, options, setFieldValue  } = props || {}
	let value = values[name];

	options = (options || []).map(({ title }, value)=> ({ title, value }));

	const onClick = (e)=>{
		(e && e.preventDefault && e.preventDefault());

		let menus = [], items = [];

		items = options.map(({ value: v, title })=>{

			let className = (value === v) ? 'item-checked': 'item';

			const sx = {
				'& .col':{ lineHeight: '40px' },
				'& .col-auto':{
					'& > div':{
						height: 'calc(100%)',
						minWidth: '30px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}
				},
				'&.item-checked':{
					color: '#0066CC'
				}
			}

			return ({
				title: ()=><>
					<Row className={className} mini sx={sx}>
						<Col>{title}</Col>
						<Col xs={'auto'}>
							{ (value === v) && <div><Checked /></div> }
						</Col>
					</Row>
				</>,
				handleClick: ()=>{
					setFieldValue(name, v)
				}
			});
		});

		menus.push({ items, type: 'group' });

		func(onActions.clicks)({
				value,
				enableClose: true,
				items: menus,
				headerProps:{ style: { padding: '7px 0' } },
				title: label
			})
	}

	let data = opt(options, value)?.title

	return <>

		<Field
			{...{ className: 'Mui-textfield', onClick, component: RenderField }}
			{...{ label, name, value: data, required }}
			{...{ dropdownIcon: { dropdownProps:{ onClick } } }}
			{...{
				sx: {
					'& .endAdornment':{
						zIndex: 10,
						position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
						cursor: 'pointer',
						'&> div, &> div > .btn':{
							width: '100% !important',
							height: '100% !important',
						},
						'&> div > .btn':{
							textAlign: 'right',
							paddingRight: '10px !important'
						}
					}
				}
			}}
		/>
	</>
})